/**
 * Grants Routes (User Grants Management)
 */
export default [
    {
        path: '/grants',
        name: 'grants',
        component: () => import('../../pages/grants/IndexPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Manage Grants',
        },
    },
];
